import React from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { BreadCrumbs } from 'SRC/modules/vehicleParts/list/components'
import { getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'
import { Filters } from '../Filters'

export const Container = ({ filterValues }) => {
  const { t, lang } = useTranslation('common')

  const locale = lang?.toUpperCase() || 'ME'

  const [isSubmitting, setIsSubmitting] = React.useState()

  const submit = async values => {
    setIsSubmitting(true)
    const urlFromValues = getUrl(values, locale)

    const href = urlFromValues.href
    const as = urlFromValues.asUrl

    Router.push(href, as).then(() => {
      setIsSubmitting(false)
    })
  }

  const formProps = {
    submit,
    filterValues: filterValues || {},
    isSubmitting,
  }

  return (
    <React.Fragment>
      <Filters {...formProps} />

      <BreadCrumbs filterValues={filterValues} />
    </React.Fragment>
  )
}

Container.propTypes = {
  filterValues: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    diameter: PropTypes.string,
    manufacturer: PropTypes.string,
    season: PropTypes.string,
    vehicle_type: PropTypes.string
  }).isRequired
}
